<template>
  <div class="header">
    <van-nav-bar
      title="专题 - 四川手机报"
      left-text=" "
      left-arrow
      @click-left="onClickLeft"
    >
      <template #right>
        <span
          v-if="statusLabel"
          class="article-status"
          :style="{ color: statusColor || '#333' }"
        >
          状态：{{ statusLabel }}
        </span>
      </template>
    </van-nav-bar>
    <div class="logocenter">
      <div class="logo">
        <van-image
          :src="back"
          fit="cover"
          width="100%"
          style="aspect-ratio: 3/1"
        >
          <template #error>
            <div class="image-placeholder">
              <van-icon name="photo-o" size="36" color="#ccc" />
              <span>暂无图片</span>
            </div>
          </template>
        </van-image>
      </div>
      <div class="topic-desc">
        <i class="iconfont icon-yinyong"></i>
        <div v-if="descHtml" class="c" v-html="desc"></div>
        <div v-else class="c">{{ desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    back: { type: String, default: "" },
    desc: { type: String, default: "" },
    title: { type: String, default: "" },
    statusLabel: { type: String, default: "" },
    statusColor: { type: String, default: "" },
    /** 为 true 时 desc 按 HTML 渲染（敏感词高亮） */
    descHtml: { type: Boolean, default: false },
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="less">
::v-deep .van-nav-bar__right {
  padding: 0;
}

.header {
  background: #fff;
}
.article-status {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.logo {
  width: 100%;
  line-height: 0;
  min-height: 130px;

  .van-image {
    display: block;
    width: 100%;
    // height: 150px;
  }
}
.image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 130px;
  background: #f5f5f5;
  color: #999;
  font-size: 12px;

  span {
    margin-top: 8px;
  }
}
.topic-desc {
  padding: 20px 40px;
  font-size: 14px;
  .iconfont {
    font-size: 26px;
    color: #999;
  }
  .c {
    line-height: 25px;
    margin-top: 10px;
    color: #999;
  }
}
</style>
